import { JsonApiGetResponse } from '~/redux/api/ApiTypes';
import { RbacPermission } from '~/types/Rbac';

import { requestPermission } from './permissionBatch';

type CheckPermissionResult = JsonApiGetResponse<
  'permission_check',
  {
    permission: boolean;
  }
>;

/**
 * Resolves one permission pair. Caching is RTK Query's job — this is the only
 * layer that talks to the network, and `requestPermission` coalesces every pair
 * asked for in the same tick into a single bulk request.
 */
export const checkPermission = async ({
  resourceId,
  resourceType,
}: RbacPermission): Promise<CheckPermissionResult> => {
  const permission = await requestPermission({ resourceId, resourceType });

  return {
    data: {
      id: '',
      type: 'permission_check',
      attributes: { permission },
    },
  };
};
